/**
 * A collection for search facet options which come back from the server as an array on searchFacet
 * @class
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/searchFacetOption';

export default class SearchFacetOptions extends Base {
	/** @override */
	constructor(models, opts = {}) {
		// do a locale (case insensitive) compare
		// providing a string to `comparator` makes it run through underscore's `sortBy`
		// and is case sensitivie
		opts.comparator =
			opts.comparator ||
			function (a, b) {
				return a.get('value').localeCompare(b.get('value'));
			};
		opts.model = opts.model || Model;

		super(models, opts);
	}

	/**
	 * Get selected options
	 * @method
	 * @return {array} Selected
	 */
	getSelected() {
		// Return an array of model attribute objects, not whole models
		return _.compact(
			_.map(
				this.filter((m) => m.get('selected')),
				(m) => m.attributes,
			),
		);
	}

	/** @type {string} */
	static get __name__() {
		return 'SearchFacetOptions';
	}
}
